export default (axios) => ({
    getSuppliers: (params) => axios.get('/b/Suppliers', { params }).then((_) => _.data),
    getSupplierBySlug: (slug, params) => axios.get(`/b/Suppliers/${slug}`, { params }).then((_) => _.data),
});
